import { useState, useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import "../styles/Navbar.css"; // Osobny plik CSS
import { FiMenu } from "react-icons/fi";
import { ReactComponent as TemplateIcon } from '../template.svg';
import { ReactComponent as AutomationIcon } from '../automatic.svg';
import { ReactComponent as WordIcon } from '../word.svg';
import { ReactComponent as UserIcon } from '../user.svg';

interface NavbarProps {
  activeTab: "files" | "automations" | "generatedFiles";
  setActiveTab: (tab: "files" | "automations" | "generatedFiles") => void;
}

const Navbar = ({ activeTab, setActiveTab }: NavbarProps) => {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    logout();
    console.log("Wylogowano!");
  };

  // 🔹 Zamykamy dropdown po kliknięciu poza nim
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="navbar enhanced-navbar">
      <div className="navbar-left" style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
        <img src="/logo2.png" style={{ width: 90, height: 90, marginRight: 8, objectFit: 'contain' }} alt="Paperly logo" />
      </div>
      <div className="navbar-tabs">
        <button
          className={`tab ${activeTab === "files" ? "active" : ""}`}
          onClick={() => setActiveTab("files")}
        >
          <WordIcon style={{ width: 20, height: 20, marginRight: 8, marginBottom: -2 }} /> Szablony
        </button>
        <button
          className={`tab ${activeTab === "automations" ? "active" : ""}`}
          onClick={() => setActiveTab("automations")}
        >
          <AutomationIcon style={{ width: 20, height: 20, marginRight: 8, marginBottom: -2 }} /> Automatyzacje
        </button>
        <button
          className={`tab ${activeTab === "generatedFiles" ? "active" : ""}`}
          onClick={() => setActiveTab("generatedFiles")}
        >
          <TemplateIcon style={{ width: 20, height: 20, marginRight: 8, marginBottom: -2 }} /> Wygenerowane dokumenty
        </button>
      </div>
      <div className="navbar-right" ref={dropdownRef}>
        <div className="profile-container" onClick={toggleDropdown} tabIndex={0} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', borderRadius: 999, padding: '6px 16px', background: '#f3f6fd', boxShadow: '0 2px 8px #e0e7ff', transition: 'box-shadow 0.18s' }}>
          <span className="avatar" style={{ width: 36, height: 36, borderRadius: '50%', background: '#2563eb', color: '#fff', fontWeight: 700, fontSize: 18, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {user?.email ? user.email[0].toUpperCase() : <UserIcon style={{ width: 22, height: 22 }} />}
          </span>
          <span className="user-email" style={{ fontSize: 15, fontWeight: 600, color: '#2563eb' }}>{user?.email}</span>
          <FiMenu size={20} color="#2563eb" />
        </div>
        {isOpen && (
          <div className="dropdown-menu enhanced-dropdown-menu fade-slide-in">
            <div className="dropdown-separator" style={{height:1, background:'#e0e7ff', margin:'4px 0 4px 0', width:'100%'}}></div>
            <button className="dropdown-item logout" onClick={handleLogout}>
              Wyloguj się
            </button>
          </div>
        )}
      </div>
      <style>{`
        .enhanced-navbar {
          background: linear-gradient(90deg, #f8fafc 0%, #e0e7ff 100%) !important;
          box-shadow: 0 2px 8px #e0e7ff !important;
          border-bottom: 1.5px solid #e0e7ff !important;
          height: 64px !important;
          padding: 0 32px !important;
          position: sticky !important;
          top: 0;
          z-index: 1000;
          transition: box-shadow 0.18s;
        }
        .enhanced-navbar.sticky-shadow {
          box-shadow: 0 6px 24px #2563eb22 !important;
        }
        .navbar-product-name {
          font-family: Sora, Inter, Arial, sans-serif;
        }
        .navbar-tabs {
          display: flex;
          align-items: center;
          gap: 24px;
          margin-left: 32px;
          margin-right: 32px;
          height: 100%;
        }
        .tab {
          background: transparent;
          border: none;
          font-size: 17px;
          font-weight: 700;
          padding: 10px 22px;
          cursor: pointer;
          transition: color 0.2s, background 0.2s, box-shadow 0.18s;
          color: #555;
          border-radius: 10px 10px 0 0;
          position: relative;
          margin-bottom: 0;
          outline: none;
          display: flex;
          align-items: center;
        }
        .tab.active {
          color: #2563eb;
          background: #fff;
          border-bottom: 3px solid #2563eb;
          font-weight: 800;
          box-shadow: 0 2px 8px #c7d2fe33;
        }
        .tab:hover, .tab:focus {
          color: #2563eb;
          background: #e0e7ff;
          outline: 2px solid #2563eb44;
        }
        .profile-container:focus, .profile-container:hover {
          box-shadow: 0 4px 16px #2563eb33 !important;
          outline: 2px solid #2563eb44;
        }
        .avatar {
          min-width: 36px;
          min-height: 36px;
          border-radius: 50%;
          background: #2563eb;
          color: #fff;
          font-weight: 700;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .enhanced-dropdown-menu {
          right: 0 !important;
          top: 58px !important;
          min-width: 180px;
          box-shadow: 0 4px 16px #2563eb22 !important;
          border-radius: 12px !important;
          background: #fff !important;
          padding: 8px 0 !important;
          animation: fadeSlideIn 0.22s cubic-bezier(.4,1.3,.6,1) both;
        }
        .dropdown-separator {
          height: 1px;
          background: #e0e7ff;
          margin: 4px 0;
          width: 100%;
        }
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(-12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 900px) {
          .enhanced-navbar {
            flex-direction: column;
            height: auto !important;
            padding: 0 8px !important;
          }
          .navbar-tabs {
            gap: 8px;
            margin-left: 0;
            margin-right: 0;
          }
          .tab {
            font-size: 15px;
            padding: 8px 10px;
          }
          .navbar-left img {
            width: 36px !important;
            height: 36px !important;
          }
          .profile-container {
            flex-direction: row;
            gap: 6px;
            padding: 6px 8px;
          }
          .user-email {
            font-size: 13px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Navbar;
